export default "__VITE_ASSET__XB$BNQNP__"